export const fundraisesSearchQuery = `
query Fundraise_search(
  $limit: Int, $offset: Int, $sort_by: String, $order_by: String, $global_search: String,
  $is_pro: Boolean, $forex_operation_max_duration: Int, $emir: Boolean
) {
  fundraise_searchs(
    fundraise_searchSearchType: {
     is_pro: $is_pro, forex_operation_max_duration: $forex_operation_max_duration, emir: $emir
    },
    table_searchSearchType: {
      limit: $limit, offset: $offset, sort_by: $sort_by, order_by: $order_by,
      global_search: $global_search
    },
    fundraise_searchSearchForDateType: {}
  ) {
    data {
      id
      created_at
      name
      category
      city
      tag
      description_short
      logo_url
      lei
      topaze_id
      is_pro
      forex_operation_max_duration
      emir
      category_principale
      category_produit
      category_segmentation
      category_partenaire_btob
      efs_code
      efs_name
      enterprise{
        ...fe7b0fd3784cb4c3d920e88fd0521d7db
      }
    }
    total_size
  }
}

fragment fe7b0fd3784cb4c3d920e88fd0521d7db on Enterprise {
  id
  name
  created_at
  activity_domain
  legal_status
  status
  tag
  description_short
  description_long
  url
  logo_url
  image_cover_url
  video_url
  website_url
  address {
    city
    zip
    number
    street
    country
  }
}
`;



// WEBPACK FOOTER //
// ./src/core/graphql/fundraiseQuery.ts